// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__adelaila_406eef', '__adelaila_Fallback_406eef'"},"className":"__className_406eef","variable":"__variable_406eef"};